import { push } from 'react-router-redux';
import * as actions from './actions';

/*
  These operations use a bit of defensive programming to make sure that
  actions are only fired when certain conditions are met. It should not be
  possible to trigger these from the UI in wrong conditions, because the
  elements would simply not be availble to trigger them (like a flip button),
  but it's nice to be absolutely sure and throw errors if unexpected conditions
  occur.
*/

/*
  Select a location on the map. This can be location a or b.
*/
const selectLocation = id => (dispatch, getState) => {
  const { segmentCreation: { selectedLocations } } = getState();

  if (selectedLocations && selectedLocations.length === 2) {
    throw new Error(`Can not select more then two locations at once`);
  }

  dispatch(actions.selectLocation(id));
};

const deselectLocation = id => (dispatch, getState) => {
  const { segmentCreation: { selectedLocations } } = getState();

  if (!selectedLocations || !selectedLocations.includes(id)) {
    throw new Error(
      `Can not deselect id ${id} because the current selection is ${selectedLocations}`
    );
  }

  dispatch(actions.deselectLocation(id));
};

const flipSelectedLocations = () => (dispatch, getState) => {
  const { segmentCreation: { selectedLocations } } = getState();

  if (!selectedLocations || !selectedLocations.length === 2) {
    throw new Error(`It takes two to flip`);
  }

  dispatch(actions.flipSelectedLocations());
};

const setPathSuggestions = pathSuggestions => dispatch => {
  // store the path suggestions and also pre-select the first one
  dispatch(actions.setPathSuggestions(pathSuggestions));
};

const selectPathSuggestion = id => (dispatch, getState) => {
  const { segmentCreation: { pathSuggestions } } = getState();

  if (!pathSuggestions || pathSuggestions.length === 0) {
    throw new Error(`There are no segment path options to select from`);
  }

  const pathSuggestion = pathSuggestions.find(option => option.id === id);

  if (!pathSuggestion) {
    throw new Error(`There is no segment path option with id ${id}`);
  }

  dispatch(actions.selectPathSuggestion(pathSuggestion));
};

const finishCreateSegment = () => dispatch => {
  dispatch(actions.clearCreateSegment());
  dispatch(push('/map/live'));
};

const clearCreateSegment = () => dispatch => {
  dispatch(actions.clearCreateSegment());
};

const startCreateOppositeSegment = () => (dispatch, getState) => {
  const { segmentCreation: { selectedLocations } } = getState();

  if (!selectedLocations || !selectedLocations.length === 2) {
    throw new Error(`In order to create the opposite segment two locations need to be selected`);
  }

  dispatch(actions.startCreateOppositeSegment());
};

export default {
  selectLocation,
  deselectLocation,
  flipSelectedLocations,
  setPathSuggestions,
  selectPathSuggestion,
  setCreatedSegmentId: actions.setCreatedSegmentId,
  finishCreateSegment,
  clearCreateSegment,
  startCreateOppositeSegment,
};



// WEBPACK FOOTER //
// ./src/state/ducks/segmentCreation/operations.js